export default __webpack_public_path__ + "437a51e.svg";